import { render, staticRenderFns } from "./SliderPreview.vue?vue&type=template&id=2504f2ac&"
import script from "./SliderPreview.vue?vue&type=script&lang=js&"
export * from "./SliderPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports